import React, { PropsWithChildren, useCallback, useState } from 'react';
import { EbookButton, EbookLayout, EbookLeftTextBox, EbookResponsiveImage, EbookRightImageBox, EbookSection } from './Ebook.style';
import { ebookBanner } from '@assets/images/solution/common';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import { Div100flex, DivFlexColumn, DivFlexRow } from '@pages/CommonStyle/commonDiv.style';
import { DisplayColor, ImgWidth100, ParagraphColor, Spacing } from '@pages/CommonStyle/common.style';
import { constAssetBanner, constSopBanner } from '@assets/images/solution';
import { Trans } from 'react-i18next';
import { BtnStyled } from '@pages/CommonStyle/commonBtn';
import { StyledLabel } from '@components/Text';
import ebook from '@src/lang/ko/ebook';
import { useLocation } from 'react-router-dom';
import Modal from '../Banner/Modal/Modal';
import ModalSubscribe from '../Banner/Modal/ModalSubscribe';
import ModalDone from '../Banner/Modal/ModalDone';

const ebookThumbnails: Record<string, string> = {
  constructionSafety: ebook.thumbnail.constructionSafety,
  constructionSop: ebook.thumbnail.constructionSop,
  constructionEquipment: ebook.thumbnail.constructionEquipment,
  constructionManage: ebook.thumbnail.constructionManage,

  logisticsAsset: ebook.thumbnail.logisticsAsset,

  manufacturingProcess: ebook.thumbnail.manufacturingProcess,
  manufacturingSteel: ebook.thumbnail.manufacturingSteel,
  manufacturingForklift: ebook.thumbnail.manufacturingForklift,

  medicalPatient: ebook.thumbnail.medicalPatient,
  medicalWaste: ebook.thumbnail.medicalWaste,

  retailOffice: ebook.thumbnail.retailOffice,
  retailExhibition: ebook.thumbnail.retailExhibition,
  retailMobile: ebook.thumbnail.retailMobile,

  cityDigital: ebook.thumbnail.cityDigital,
  cityTraffic: ebook.thumbnail.cityTraffic,

  publicSafety: ebook.thumbnail.publicSafety,
  publicFire: ebook.thumbnail.publicFire,
  publicCrosswalk: ebook.thumbnail.publicCrosswalk,

  educationSafety: ebook.thumbnail.educationSafety,
  digitaltwin: ebook.thumbnail.digitaltwin,
};

interface ModalDefaultType {
  pageName: string;
  path: any;
}

const Ebook: React.FC<PropsWithChildren<ModalDefaultType>> = ({ pageName, path }) => {
  const location = useLocation();
  const [isDownload, setDownloadModal] = useState(false);
  const [isSubscribeOpen, setSubscribeOpen] = useState(false);
  const [isDoneOpen, setDoneOpen] = useState(false);

  const [getEmail, onGetEmail] = useState<string>('');
  const handleSaveEmail = (email) => {
    onGetEmail(email);
  };

  const onClickToggleModal = useCallback(() => {
    setDownloadModal(!isDownload);
  }, []);
  const onSuccess = useCallback(() => {
    setDownloadModal(false);
  }, []);

  const onSubscribe = () => {
    setSubscribeOpen(!isSubscribeOpen);
  };
  const onDone = () => {
    setDoneOpen(!isDoneOpen);
  };

  const thumbnailSrc = ebookThumbnails[pageName] || constSopBanner; // fallback 이미지
  console.log('pageName : ', pageName);
  return (
    <>
      <EbookLayout bgImg={ebookBanner}>
        <StyledGridContainer>
          <EbookSection>
            <EbookLeftTextBox>
              <DisplayColor size="small" color="#fff">
                <Trans i18nKey={`ebook.title`} />
              </DisplayColor>
              <Spacing pixel="8" />
              <ParagraphColor size="medium" color="#fff">
                <Trans i18nKey={`ebook.desc`} />
              </ParagraphColor>
              <Spacing pixel="24" />
              <EbookButton onClick={onClickToggleModal}>
                <StyledLabel size="medium">
                  <Trans i18nKey={`ebook.buttonText`} />
                </StyledLabel>
              </EbookButton>
              <Spacing pixel="32" />
            </EbookLeftTextBox>
            <EbookRightImageBox>
              <EbookResponsiveImage src={thumbnailSrc} alt="Digital Twin Solution" />
            </EbookRightImageBox>
          </EbookSection>
        </StyledGridContainer>

        {isDownload && (
          <Modal onClickToggleModal={onSuccess} content="download" onSubscribe={onSubscribe} onSaveEmail={handleSaveEmail} pageName={pageName}></Modal>
        )}

        {isSubscribeOpen && <ModalSubscribe onClickToggleModal={onSubscribe} onDone={onDone} email={getEmail}></ModalSubscribe>}

        {isDoneOpen && <ModalDone onClickToggleModal={onDone}></ModalDone>}
      </EbookLayout>
    </>
  );
};

export default Ebook;
